import {
  faArrowLeft,
  faEnvelope,
  faMap,
  faMapMarker,
  faMobile,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Full_screen_modal from "../common_component/full_screen_modal/Full_screen_modal";
import Send_Btn from "../common_component/send_btn/Send_Btn";
import "./Contact_Us.css";
import {  faThreads } from "@fortawesome/free-brands-svg-icons";

const Contact_Us = () => {
  const [showMap, setShowMap] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const socialIcons = [
    { icon: FaFacebook, link: "https://www.facebook.com/share/17xh1pQu18/" },
    { icon: FaTwitter, link: "https://youtube.com/@pmroad?si=-8XQNJt4daYb2WiF" },
    { icon: FaYoutube, link: "https://x.com/PMROAD1" },
    { icon: FaInstagram, link: "https://www.instagram.com/pm.road?utm_source=qr&igsh=MXdubzJpbnI4ODhkdA==" },
    { icon: faThreads, link: "https://www.threads.com/@pm.road" },
  ];

  const {
    register,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>
            tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.subject}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "vaishnavishinde0803@gmail.com",
        subject: "demo",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 2500);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <section className="contact-section">
      <div className={`map-bg-container ${showMap ? "show-map" : ""}`}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.1160973656!2d73.72287999999999!3d18.524564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1c9fd467891%3A0xdea0df2183d2ddba!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          className="map-iframe"
        ></iframe>
      </div>
      <div className="contact_holder">
        <Container>
          <Row>
            <Col lg={4} className={showMap ? "d-none" : ""}>
              <div className="left-section">
                <h2 className="contact-title">Contact Us</h2>

                <div className="contact-info-item">
                  <div className="icons_holder">
                    <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                  </div>
                  <span className="contact-span">+91 95520974</span>
                </div>

                <div className="contact-info-item">
                  <div className="icons_holder">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="contact-icon"
                    />
                  </div>
                  <span className="contact-span">help.pmroad@gmail.com</span>
                </div>

                <div className="contact-info-item">
                  <div className="icons_holder">
                    <FontAwesomeIcon
                      icon={faMapMarker}
                      className="contact-icon"
                    />
                  </div>
                  <span className="contact-span">
                    Akshya Nagar 1st Block 1st Cross,
                    <br />
                    Rammmurthy nagar, Pune - 411038
                  </span>
                </div>

                <div className="contact-info-item">
                  <div className="icons_holder">
                    <FontAwesomeIcon icon={faMap} className="contact-icon" />
                  </div>
                  <span className="contact-span">
                    <a
                      href="#"
                      className="map-link"
                      onClick={() => setShowMap(true)}
                    >
                      Find Us on Map
                    </a>
                  </span>
                </div>

                <hr className="divider" />

                <div className="contact-info-item">
                  <div className="icons_holder">
                    <FontAwesomeIcon icon={faMobile} className="contact-icon" />
                  </div>
                  <span className="contact-span">
                    <div className="social-icon">
                      {socialIcons.map((item, index) => (
                        <div className="circle_box" key={index}>
                          <div className="icons">
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="link"
                            >
                              <item.icon className="icon_class" />
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </span>
                </div>
              </div>
            </Col>

            <Col
              lg={8}
              className={`right-col ${showMap ? "right-expanded" : ""}`}
            >
              <div className="right-section">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  {/* Name */}
                  <Form.Group className="input_group">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      {...register("name", {
                        required: "Name is required",
                      })}
                      className={classNames("", {
                        "is-valid": getValues("name"),
                      })}
                    />
                    {errors?.name && (
                      <span className="invalid-feedback d-block">
                        {errors.name.message}
                      </span>
                    )}
                  </Form.Group>

                  
                  <Form.Group className="input_group">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Email address"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Invalid email address",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.email,
                        "is-valid": getValues("email"),
                      })}
                    />
                    {errors?.email && (
                      <span className="invalid-feedback d-block">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="input_group">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Subject"
                      {...register("subject", {
                        required: "subject is required",
                      })}
                      className={classNames("", {
                        "is-valid": getValues("subject"),
                      })}
                    />
                    {errors?.subject && (
                      <span className="invalid-feedback d-block">
                        {errors.subject.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="input_group">
                    <Form.Control
                      as="textarea"
                      name="message"
                      placeholder="Your message"
                      rows={4}
                      {...register("message", {
                        required: "Message is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.message,
                        "is-valid": getValues("message"),
                      })}
                    />
                    {errors?.message && (
                      <span className="invalid-feedback d-block">
                        {errors.message.message}
                      </span>
                    )}
                  </Form.Group>

                  <div className="button">
                    {!formSubmitted && <Send_Btn type="submit" />}
                  </div>

                  {showMap && (
                    <button
                      type="button"
                      className="back-btn"
                      onClick={() => setShowMap(false)}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Full_screen_modal
        show={showModal}
        onHide={() => setShowModal(false)}
        
      />
    </section>
  );
};

export default Contact_Us;
